import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// ID-046 RC-CS-SPEC-002: every issued production-spec version as stored, with the active one highlighted
export function FinalSpecVersions({ base, refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`${base}/final-spec/versions`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [base, refreshKey]);
  if (!items || !items.length) return null;
  return (
    <div className="mt-4 rounded-md border border-border bg-white p-4" data-testid="final-spec-versions">
      <p className="text-xs font-semibold uppercase tracking-wider text-warmgrey">Production specification versions</p>
      {items.map((v) => (
        <div key={v.final_version} className={`mt-2 rounded-md border p-3 text-xs ${v.current ? "border-terracotta bg-terracotta/5" : "border-border"}`} data-testid={`final-spec-version-${v.final_version}`}>
          <p className="font-semibold text-charcoal">
            v{v.final_version} {v.current && <span className="ml-1 rounded-full bg-terracotta px-2 py-0.5 text-[10px] text-white" data-testid={`final-spec-version-${v.final_version}-current`}>Active</span>}
            <span className="ml-2 font-normal text-warmgrey" data-testid={`final-spec-version-${v.final_version}-state`}>{v.state}</span>
          </p>
          <p className="mt-1 text-charcoal" data-testid={`final-spec-version-${v.final_version}-qty`}>Final quantity: {v.final_quantity_sqft} sq ft</p>
          <p className="text-charcoal" data-testid={`final-spec-version-${v.final_version}-instr`}>Special instructions: {v.special_instructions || "none"}</p>
          <p className="text-muted-foreground">Issued {new Date(v.generated_at).toLocaleString()} by {v.author} · {v.revision_ref}{v.approved_at ? ` · approved ${new Date(v.approved_at).toLocaleString()}` : ""}</p>
          {v.feedback.map((f, i) => <p key={i} className="mt-1 text-warmgrey" data-testid={`final-spec-version-${v.final_version}-feedback-${i}`}>Dealer feedback ({new Date(f.at).toLocaleString()}): {f.text}</p>)}
        </div>
      ))}
    </div>
  );
}
